import { render } from "./BidderSettingCategoryView.vue?vue&type=template&id=027a8e1c&scoped=true"
import script from "./BidderSettingCategoryView.vue?vue&type=script&lang=js"
export * from "./BidderSettingCategoryView.vue?vue&type=script&lang=js"

import "./BidderSettingCategoryView.vue?vue&type=style&index=0&id=027a8e1c&lang=scss&scoped=true"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027a8e1c"]])

export default __exports__